export enum IntermediaryChannel {
  CREATE = 'intermediary::create',
  EDIT = 'intermediary::patch',
  DELETE = 'intermediary::delete',
}
